export type GossipSection = {
  heading: string;
  paragraphs: string[];
};

export type GossipArticle = {
  id: string;
  title: string;
  summary: string;
  category: string;
  categorySlug: string;
  cover: string;
  author: string;
  date: string;
  readTime: string;
  views: number;
  tags: string[];
  hot: boolean;
  sections: GossipSection[];
};

export const categories = [
  { slug: 'star', name: '明星动态', desc: '行程、动态与一手爆料', icon: 'ri-user-star-line' },
  { slug: 'screen', name: '影视热议', desc: '热播剧集与电影口碑', icon: 'ri-film-line' },
  { slug: 'variety', name: '综艺八卦', desc: '综艺名场面与赛制讨论', icon: 'ri-mic-line' },
  { slug: 'music', name: '音乐现场', desc: '演唱会、专辑与舞台', icon: 'ri-music-2-line' },
  { slug: 'creator', name: '网红社区', desc: '主播、达人与社区生态', icon: 'ri-live-line' },
  { slug: 'life', name: '情感话题', desc: '情感观察与生活共鸣', icon: 'ri-heart-3-line' },
];

export const articles: GossipArticle[] = [
  {
    id: '1001',
    title: '顶流恋情疑云再起，多方回应后话题持续发酵',
    summary:
      '一条深夜同框的路透让话题迅速冲上热搜，当事双方先后发文回应，粉丝与路人各执一词，吃瓜现场一度十分热闹。',
    category: '明星动态',
    categorySlug: 'star',
    cover:
      'https://readdy.ai/api/search-image?query=Stylized%20entertainment%20news%20editorial%20scene%20with%20warm%20coral%20and%20gold%20stage%20lights%2C%20abstract%20spotlight%20bokeh%2C%20festival%20confetti%2C%20magazine%20cover%20style%2C%20no%20text%2C%20elegant%20and%20modern&width=1200&height=700&seq=gossip-star-1001&orientation=landscape',
    author: '瓜田小队长',
    date: '2026-09-08',
    readTime: '6 分钟',
    views: 186420,
    tags: ['明星动态', '恋情', '热搜'],
    hot: true,
    sections: [
      {
        heading: '路透曝光，话题一夜冲顶',
        paragraphs: [
          '事情的起点是一组深夜街拍。有网友在某商圈偶遇两位人气艺人一前一后走出同一栋楼，画面里两人刻意保持距离，却被细心的路人发现外套与配饰高度相似。图片在凌晨流出后，相关话题在两小时内冲上热搜前列。',
          '需要说明的是，路透画面本身并不能直接证明什么，但在吃瓜语境里，它已经足够点燃讨论。评论区很快分成几派：有人翻出行程表做时间线，有人表示只是朋友聚会，也有人呼吁先等官方回应。',
        ],
      },
      {
        heading: '双方先后发文，措辞耐人寻味',
        paragraphs: [
          '当天下午，男方工作室率先发文，强调艺人目前专注工作，对于私人行程不予回应。短短两小时后，女方经纪公司也给出了类似表述，但补充了一句「希望大家把注意力放在作品上」，被不少网友解读为有所保留。',
          '公关话术的微妙差别成了新的解读素材。有从业者分析，这类回应通常由团队内部评估后统一口径，措辞越模糊，留给外界的想象空间就越大，话题也往往能多延续几天。',
        ],
      },
      {
        heading: '粉丝与路人，各有一套叙事',
        paragraphs: [
          '粉丝群体普遍倾向于「不实传闻」，他们整理出完整的工作行程，指出当晚双方都有剧组任务。路人则更关注后续是否有更多同框画面，认为单次路透不足以定性。',
          '无论真相如何，这场讨论已经给双方带来可观的热度。对内容社区来说，这类事件的看点从来不只在结果，更在于围绕它产生的各种解读与二次创作。',
        ],
      },
    ],
  },
  {
    id: '1002',
    title: '年度古装大剧开播，口碑两极分化引全网复盘',
    summary:
      '投资规模不小的古装剧上线首周，服化道收获一致好评，剧情节奏却分成两派评价，二创与考据帖同时增多。',
    category: '影视热议',
    categorySlug: 'screen',
    cover:
      'https://readdy.ai/api/search-image?query=Cinematic%20ancient%20chinese%20palace%20corridor%20in%20mist%2C%20warm%20amber%20and%20teal%20toned%20lighting%2C%20stylized%20ink%20painting%20atmosphere%2C%20elegant%20magazine%20editorial%2C%20no%20text&width=1200&height=700&seq=gossip-screen-1002&orientation=landscape',
    author: '追剧考据组',
    date: '2026-09-07',
    readTime: '8 分钟',
    views: 132870,
    tags: ['影视热议', '古装剧', '口碑'],
    hot: true,
    sections: [
      {
        heading: '服化道先行，质感获认可',
        paragraphs: [
          '开播首日，讨论最集中的是美术与造型。剧组在场景与服饰上投入明显，实景搭建的府邸、手工刺绣的纹样都被观众逐帧截图。多位服装设计从业者在社交平台给出了正面评价。',
          '配乐同样是加分项。主题曲由民乐与交响乐融合编制，前奏一响就有观众表示「起鸡皮疙瘩」，相关片段被大量剪辑传播。',
        ],
      },
      {
        heading: '节奏争议：慢热还是拖沓',
        paragraphs: [
          '好评之外，争议集中在剧情推进。前四集铺陈较多，主要人物陆续登场，但核心冲突迟迟没有拉开，一部分观众认为这是「慢热铺垫」，另一部分则直言「节奏拖沓」。',
          '编剧团队在采访中回应，故事采用先立人物再推矛盾的结构，希望观众耐心看到第八集。这个说法能否说服观众，还要看后续剧情的完成度。',
        ],
      },
      {
        heading: '二创与考据同步升温',
        paragraphs: [
          '有意思的是，争议反而带动了二创。考据党整理了剧中器物与历史原型的对应关系，剪辑党则用不同视角重新解读关键镜头，社区里的讨论热度持续走高。',
          '对一部剧而言，能被认真讨论本身就是一种信号。无论最终评分如何，它已经稳稳占据了这段时间的话题中心。',
        ],
      },
    ],
  },
  {
    id: '1003',
    title: '老牌综艺回归，全新赛制让观众直呼上头',
    summary:
      '停播一年后回归的综艺换了赛制与舞台，首期就出现名场面，选手之间的临场反应成为社区热议焦点。',
    category: '综艺八卦',
    categorySlug: 'variety',
    cover:
      'https://readdy.ai/api/search-image?query=Colorful%20tv%20studio%20stage%20with%20neon%20coral%20and%20teal%20lights%2C%20geometric%20set%20design%2C%20stylized%20entertainment%20show%20backdrop%2C%20festive%20and%20playful%2C%20no%20text&width=1200&height=700&seq=gossip-variety-1003&orientation=landscape',
    author: '综艺速报',
    date: '2026-09-06',
    readTime: '5 分钟',
    views: 98760,
    tags: ['综艺八卦', '赛制', '名场面'],
    hot: true,
    sections: [
      {
        heading: '赛制改版，节奏明显加快',
        paragraphs: [
          '本季最大的变化是取消了以往的分组淘汰，改成每期即时积分。这个调整让每轮表演都直接关系到当期排名，选手压力肉眼可见地上升，节目的紧张感也随之增强。',
          '导演组在采访中表示，改版是为了让观众更快看到结果，减少冗长的铺垫。从首期反馈来看，这个目标基本达到了。',
        ],
      },
      {
        heading: '名场面来自一次意外',
        paragraphs: [
          '首期最出圈的片段并非精心设计的舞台，而是一次道具故障。选手临场用即兴互动化解了尴尬，全场笑声不断，这段画面被剪成多个版本在社区流传。',
          '有观众认为，这类未经设计的瞬间正是综艺最可贵的地方，它让人看到真实反应，也让节目更有「人味」。',
        ],
      },
      {
        heading: '社区讨论回到内容本身',
        paragraphs: [
          '值得一提的是，这一季的讨论焦点更多落在舞台与作品上，而不是选手之间的摩擦。相关话题下的高赞评论大多在分析表演细节，整体氛围较为健康。',
          '对一档陪伴观众多年的节目来说，能持续产出讨论点，本身就是它生命力的证明。',
        ],
      },
    ],
  },
  {
    id: '1004',
    title: '巡回演唱会门票秒空，舞台设计被赞用心',
    summary:
      '新一轮巡演开票即售罄，主办方临时加场回应热情，现场舞台的机械结构与视觉设计成为乐迷讨论重点。',
    category: '音乐现场',
    categorySlug: 'music',
    cover:
      'https://readdy.ai/api/search-image?query=Concert%20stage%20with%20geometric%20lighting%20sculptures%2C%20coral%20and%20warm%20amber%20beams%2C%20haze%20and%20spotlights%2C%20stylized%20music%20festival%20atmosphere%2C%20no%20text&width=1200&height=700&seq=gossip-music-1004&orientation=landscape',
    author: '现场观演团',
    date: '2026-09-05',
    readTime: '6 分钟',
    views: 87540,
    tags: ['音乐现场', '演唱会', '舞台'],
    hot: false,
    sections: [
      {
        heading: '开票即空，加场回应热情',
        paragraphs: [
          '巡演首站开票不到十分钟便显示售罄，大量乐迷在社交平台留言求票。主办方随后宣布在同一城市加开一场，并表示会优化购票流程，减少排队压力。',
          '主办方同时提醒，切勿通过非官方渠道转让门票，以免造成不必要的损失。',
        ],
      },
      {
        heading: '舞台机械，成为隐藏主角',
        paragraphs: [
          '从现场流出的画面看，本次舞台大量使用可移动模块，配合灯光在不同曲目中呈现完全不同的空间感。乐迷把这一设计称为「会呼吸的舞台」。',
          '技术团队介绍，为了兼顾视觉与安全，整套结构经过多轮测试，确保在高强度演出下依然稳定。',
        ],
      },
      {
        heading: '歌单编排，兼顾新旧',
        paragraphs: [
          '歌单方面，演唱会既保留了多首代表作，也首次现场演唱了新专辑中的两首歌曲。新旧曲目交替编排，让现场的情绪有起有伏。',
          '有乐迷表示，能在同一场演出里听到过去与现在，是这次巡演最打动人的地方。',
        ],
      },
    ],
  },
  {
    id: '1005',
    title: '头部主播宣布暂别直播，粉丝留言区直接刷屏',
    summary:
      '一场常规直播进入了尾声，主播突然提到要休息一段时间，消息公布后社区迅速反应，团队也给出了后续安排。',
    category: '网红社区',
    categorySlug: 'creator',
    cover:
      'https://readdy.ai/api/search-image?query=Warm%20cozy%20streaming%20studio%20with%20ring%20light%20and%20coral%20accent%20decor%2C%20soft%20evening%20ambience%2C%20stylized%20creator%20workspace%2C%20no%20text&width=1200&height=700&seq=gossip-creator-1005&orientation=landscape',
    author: '社区观察员',
    date: '2026-09-04',
    readTime: '5 分钟',
    views: 76420,
    tags: ['网红社区', '直播', '动态'],
    hot: false,
    sections: [
      {
        heading: '一场普通的直播，意外的结尾',
        paragraphs: [
          '这场直播本来和往常没有区别，主播照例和观众聊天、玩游戏。临近结束时，主播停顿了一下，说想休息一段时间，把状态调整好再回来。',
          '弹幕瞬间被「等你回来」刷满，也有观众表达不舍，希望这段时间能好好休息。',
        ],
      },
      {
        heading: '团队回应：内容不断更',
        paragraphs: [
          '次日，团队发布说明，确认主播进入个人休整期，同时表示账号内容不会停更，会由团队持续更新日常与幕后。',
          '团队还提到，休整期不接商务合作，希望大家把关注留给内容本身。',
        ],
      },
      {
        heading: '社区里的两种情绪',
        paragraphs: [
          '在相关讨论中，有人理解长期高密度直播带来的压力，也有人担心复出时间不确定。更多人选择留言支持，认为健康的创作状态比频繁开播更重要。',
          '这类事件也让「创作者如何保持可持续输出」成为社区里被认真讨论的话题。',
        ],
      },
    ],
  },
  {
    id: '1006',
    title: '情感观察节目走红，素人故事为什么引发共鸣',
    summary:
      '一档素人情感观察节目悄悄出圈，没有大明星加持，却靠真实的生活片段让观众看到自己，讨论度持续走高。',
    category: '情感话题',
    categorySlug: 'life',
    cover:
      'https://readdy.ai/api/search-image?query=Warm%20sunset%20living%20room%20interior%20with%20soft%20amber%20light%2C%20cozy%20minimal%20furniture%2C%20gentle%20emotional%20atmosphere%2C%20stylized%20editorial%20photography%2C%20no%20text&width=1200&height=700&seq=gossip-life-1006&orientation=landscape',
    author: '情感编辑部',
    date: '2026-09-03',
    readTime: '7 分钟',
    views: 65230,
    tags: ['情感话题', '观察节目', '共鸣'],
    hot: false,
    sections: [
      {
        heading: '没有剧本感，反而更动人',
        paragraphs: [
          '节目把镜头对准普通人的日常：异地恋的坚持、父母与子女的沟通、刚步入职场的迷茫。没有刻意制造冲突，很多片段平淡得像生活本身。',
          '正是这种平淡，让观众在弹幕里写下「这就是我」。真实，成了这档节目最稀缺的质感。',
        ],
      },
      {
        heading: '观察室的价值在于「不评判」',
        paragraphs: [
          '观察室嘉宾的处理方式也值得一提。他们没有急着给出对错判断，而是尝试理解每个人的处境，把选择权留给当事人。',
          '有心理咨询从业者在评论中肯定这种做法，认为公开讨论情感议题时，保持克制比输出观点更重要。',
        ],
      },
      {
        heading: '共鸣之外，也要保持边界',
        paragraphs: [
          '当然，素人走上镜头也带来了边界问题。节目组表示，录制前会与参与者充分沟通，并尊重他们随时退出或保留部分内容的意愿。',
          '对观众来说，被故事打动的同时，也值得记住镜头背后是一个个真实的人。',
        ],
      },
    ],
  },
  {
    id: '1007',
    title: '实力派演员低调参与公益，行程曝光后零宣传',
    summary:
      '一组公益探访的路透被志愿者分享，随后被证实是某位实力派演员的低调行程，团队全程未做任何宣传。',
    category: '明星动态',
    categorySlug: 'star',
    cover:
      'https://readdy.ai/api/search-image?query=Quiet%20charity%20event%20scene%20with%20warm%20soft%20light%2C%20cardboard%20boxes%20and%20plants%2C%20understated%20warm%20tones%2C%20stylized%20documentary%20photography%2C%20no%20text&width=1200&height=700&seq=gossip-star-1007&orientation=landscape',
    author: '瓜田小队长',
    date: '2026-09-02',
    readTime: '4 分钟',
    views: 54980,
    tags: ['明星动态', '公益', '口碑'],
    hot: false,
    sections: [
      {
        heading: '路透来自志愿者的一条动态',
        paragraphs: [
          '事情的起因很朴素：一位志愿者在社交平台分享了探访活动的合影，画面角落里的身影被网友认出是某位实力派演员。',
          '随后有参与机构确认，该演员已在数月内多次参与相关工作，但从未对外发布任何消息。',
        ],
      },
      {
        heading: '零宣传，反而获得更多尊重',
        paragraphs: [
          '在流量为王的语境下，这样的低调显得格外难得。许多网友表示，比起精致的宣传物料，这种不声张的参与更让人信服。',
          '也有粉丝提醒，不必过度打扰，尊重当事人的节奏就是最好的支持。',
        ],
      },
      {
        heading: '让注意力回到事情本身',
        paragraphs: [
          '讨论热度的背后，更值得关注的是活动本身。据志愿者介绍，本次探访主要围绕乡村儿童阅读展开，希望更多人关注阅读资源的均衡。',
          '对内容社区来说，把话题引向更有价值的讨论，或许比单纯的围观更有意义。',
        ],
      },
    ],
  },
  {
    id: '1008',
    title: '悬疑剧结局大反转，网友连夜复盘找伏笔',
    summary:
      '一部小成本悬疑剧用结局完成逆袭，观众自发整理线索时间线，剧中细节被反复解读，成为近期讨论度最高的话题之一。',
    category: '影视热议',
    categorySlug: 'screen',
    cover:
      'https://readdy.ai/api/search-image?query=Moody%20dark%20teal%20city%20alley%20at%20night%20with%20warm%20amber%20street%20lamp%2C%20rain%20reflections%2C%20stylized%20mystery%20thriller%20atmosphere%2C%20no%20text&width=1200&height=700&seq=gossip-screen-1008&orientation=landscape',
    author: '追剧考据组',
    date: '2026-09-01',
    readTime: '7 分钟',
    views: 71260,
    tags: ['影视热议', '悬疑', '结局'],
    hot: false,
    sections: [
      {
        heading: '结局播出，评分一夜回升',
        paragraphs: [
          '开播时因为节奏偏慢，这部剧的讨论并不算热烈。但随着大结局播出，评分出现明显回升，原因在于结局回收了前面积累的大量细节。',
          '不少观众表示，看完结局再回头重看，才发现很多镜头其实早有提示。',
        ],
      },
      {
        heading: '复盘热潮：细节成为宝藏',
        paragraphs: [
          '社区里很快出现了完整的时间线整理，从道具摆放到台词停顿，观众把可疑之处逐一标注，形成一份份「观剧指南」。',
          '编剧在互动中回应，部分细节确实是刻意设计，希望观众能获得二次观看的乐趣。',
        ],
      },
      {
        heading: '小成本也能讲好故事',
        paragraphs: [
          '这部剧的制作规模并不大，没有豪华阵容，也缺少大规模宣传，最终却靠扎实的剧本赢得口碑。',
          '它的走红再次说明，在内容行业里，讲好一个故事永远是最有效的传播方式。',
        ],
      },
    ],
  },
  {
    id: '1009',
    title: '乐队新专辑风格转向，两极评价背后是什么',
    summary:
      '成军多年的乐队发布新专辑，整体风格明显转向，老歌和新歌的对比让讨论迅速升温，乐评人与乐迷各抒己见。',
    category: '音乐现场',
    categorySlug: 'music',
    cover:
      'https://readdy.ai/api/search-image?query=Analog%20recording%20studio%20with%20warm%20amber%20lighting%2C%20vintage%20guitars%20and%20mixer%20console%2C%20cozy%20creative%20space%2C%20stylized%20editorial%2C%20no%20text&width=1200&height=700&seq=gossip-music-1009&orientation=landscape',
    author: '现场观演团',
    date: '2026-08-30',
    readTime: '6 分钟',
    views: 43870,
    tags: ['音乐现场', '专辑', '风格'],
    hot: false,
    sections: [
      {
        heading: '从躁动到内敛',
        paragraphs: [
          '新专辑放弃了以往标志性的高声量编曲，转向更克制的器乐表达。制作上大量使用现场同步录音，保留了演奏中的呼吸感。',
          '有乐迷认为这是乐队的成熟，也有人怀念过去更有冲劲的样子，两种声音在评论区反复碰撞。',
        ],
      },
      {
        heading: '创作者的自我说明',
        paragraphs: [
          '主创在采访中解释，这种变化来自这几年的生活体验，他们不想重复自己，哪怕代价是失去一部分听众。',
          '他还提到，专辑里的每首歌都有具体的场景，希望听众戴着耳机在夜晚独自聆听。',
        ],
      },
      {
        heading: '争议本身也是价值',
        paragraphs: [
          '乐评人指出，能够引发讨论的转型，说明乐队仍具备被认真对待的分量。真正危险的从来不是争议，而是无人关心。',
          '对新听众来说，这张专辑也提供了一个进入乐队作品的入口。',
        ],
      },
    ],
  },
  {
    id: '1010',
    title: '达人转型带货，选品团队首次公开幕后流程',
    summary:
      '一位内容达人宣布转向直播带货，团队首次公开选品流程与试用机制，回应外界对内容创作者商业化的关注。',
    category: '网红社区',
    categorySlug: 'creator',
    cover:
      'https://readdy.ai/api/search-image?query=Modern%20ecommerce%20warehouse%20shelves%20with%20neat%20packages%2C%20warm%20coral%20and%20amber%20accents%2C%20clean%20stylized%20commercial%20photography%2C%20no%20text&width=1200&height=700&seq=gossip-creator-1010&orientation=landscape',
    author: '社区观察员',
    date: '2026-08-28',
    readTime: '5 分钟',
    views: 39150,
    tags: ['网红社区', '带货', '选品'],
    hot: false,
    sections: [
      {
        heading: '转型背后的考量',
        paragraphs: [
          '这位达人过去以测评内容为主，积累了稳定的口碑。宣布转做直播带货后，讨论集中在「内容会不会变味」这个问题上。',
          '团队回应，希望把测评积累的判断力用在选品上，而不是单纯追求销量。',
        ],
      },
      {
        heading: '选品流程被完整公开',
        paragraphs: [
          '为了回应质疑，团队首次公开了流程：先由买手初筛，再由团队匿名试用两周，通过后才进入直播清单，未通过的样品会退回或留档说明。',
          '团队表示，任何一款产品只要能证明存在夸大宣传，都会被立即下架。',
        ],
      },
      {
        heading: '口碑需要长期建立',
        paragraphs: [
          '业内人士认为，公开流程是好的开始，但真正的考验在于长期执行。用户的信任一旦受损，很难通过一两次说明恢复。',
          '对社区而言，理性看待创作者的选择，同时保持监督，或许是更健康的态度。',
        ],
      },
    ],
  },
];

export const communityGroups = [
  {
    name: '爆瓜福利 · 官方吃瓜群',
    platform: '微信群',
    capacity: '500 人 / 群，已建 12 群',
    code: 'BGFL-2026-A1',
    note: '每日推送最新爆料合集，进群请注明来源。',
    icon: 'ri-wechat-line',
  },
  {
    name: '爆瓜福利 · 热门话题分享群',
    platform: 'QQ 群',
    capacity: '2000 人 / 群，已建 6 群',
    code: '8826 0041',
    note: '影视综艺音乐专题讨论，禁止剧透攻击。',
    icon: 'ri-qq-line',
  },
  {
    name: '爆瓜福利 · 分享链接合集',
    platform: '资源页',
    capacity: '每周更新 1 次',
    code: 'LINK-0926',
    note: '整理本周值得一看的内容链接，仅收录原创与正规来源。',
    icon: 'ri-links-line',
  },
  {
    name: '爆瓜福利 · 分享码领取',
    platform: '分享码',
    capacity: '每日限量发放',
    code: 'SHARE-0926',
    note: '用于访问站内专题页，有效期 7 天。',
    icon: 'ri-qr-code-line',
  },
];

export const faqs = [
  {
    q: '「爆瓜福利」主要提供什么内容？',
    a: '我们聚焦娱乐吃瓜话题，涵盖明星动态、影视热议、综艺八卦、音乐现场、网红社区与情感话题六大方向，聚合最新爆料与有阅读价值的内容，帮助用户在碎片时间快速了解热点。',
  },
  {
    q: '怎样加入爆瓜福利分享群？',
    a: '前往「分享社区」页面即可查看当前开放的微信群、QQ 群信息，按提示填写来源说明后申请加入。为避免打扰，每个群都设置了人数上限，满员后会不定期开放新群。',
  },
  {
    q: '分享链接和分享码有什么区别？',
    a: '分享链接用于直接访问站内专题合集，会定期更新与失效；分享码是一串短期有效的邀请码，可用于访问限时专题或加入特定群组。两者都会在分享社区页统一公布。',
  },
  {
    q: '内容多久更新一次？',
    a: '热点内容通常当天跟进，深度整理类内容每周更新。分享链接合集固定在每周一更新，分享码则视活动安排每日限量发放。',
  },
  {
    q: '发现内容有误或想投稿怎么办？',
    a: '可以通过「关于我们」页面提供的邮箱联系我们，注明文章链接与具体问题，我们会尽快核实处理。欢迎提供线索，但请确保信息真实、来源可查。',
  },
  {
    q: '网站会不会泄露我的个人信息？',
    a: '本站为内容资讯站，浏览内容不需要注册，也不收集个人敏感信息。加入社群时请自行判断，不要在群内透露身份证、银行卡等敏感资料。',
  },
];